import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-coaching-activity-status-wrapper',
    template: ` <div
            class="cmps-coaching-activity-status-wrapper--label"
            [style.backgroundColor]="color"
            *ngIf="label"
        >
            <span>{{ label }}</span>
        </div>
        <div class="cmps-coaching-activity-status-wrapper--content">
            <ng-content></ng-content>
        </div>`,
    host: {
        class: 'cmps-coaching-activity-status-wrapper',
        '[style.borderColor]': 'color',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsActivityStatusWrapperComponent {
    @Input() color: string;
    @Input() label: string;
}
